module.exports = __webpack_public_path__ + "static/media/multiModalFlat.dbda3bfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/multiModalFlat.jpg
// module id = 189
// module chunks = 0